import { render, staticRenderFns } from "./FileUploadItem.vue?vue&type=template&id=308c8b52&scoped=true"
import script from "./FileUploadItem.vue?vue&type=script&lang=js"
export * from "./FileUploadItem.vue?vue&type=script&lang=js"
import style0 from "./FileUploadItem.vue?vue&type=style&index=0&id=308c8b52&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308c8b52",
  null
  
)

export default component.exports